export const ORGANIZATION_IMPERSONATE_PERMISSION = 'organization.impersonate';
export const ORGANIZATION_LIST_PERMISSION = 'organization.list';
export const ORGANIZATION_EDIT_PERMISSION = 'organization.edit';
export const ORGANIZATION_LIST_USERS_PERMISSION = 'organization.user.list';
export const ORGANIZATION_CREATE_USER_PERMISSION = 'organization.user.create';
export const ORGANIZATION_RESEND_USER_VERIFICATION_EMAIL_PERMISSION = 'organization.user.verification.resend';
export const ORGANIZATION_SEND_USER_PASSWORD_RESET_PERMISSION = 'organization.user.password.reset';
export const ORGANIZATION_DELETE_USER_PERMISSION = 'organization.user.delete';

// Stats
export const STATS_USAGE_PERMISSION = 'stats.usage';
// Billing
export const BILLING_GRANT_PERMISSION = 'billing.grant_manual';
export const BILLING_SUBSCRIPTION_MANUAL_PERMISSION = 'billing.subscription_manual';
export const BILLING_MANAGE_PERMISSION = 'billing.manage';
export const BILLING_PURCHASE_PACK_PERMISSION = 'billing.purchase.pack';
export const BILLING_PURCHASE_SUBSCRIPTION_PERMISSION = 'billing.purchase.subscription';

// Printers
export const PRINTER_REGISTRATION_CODE_CREATE_PERMISSION = 'printer.registration_code.create';
export const PRINTER_LIST_PERMISSION = 'printer.list';
export const PRINTER_DELETE_PERMISSION = 'printer.delete';
export const PRINTER_JOB_CREATE_PERMISSION = 'printer.job.create';
export const PRINTER_JOB_LABEL_PERMISSION = 'printer.job.label';

// Translations
export const TRANSLATION_ROLLBACK_PERMISSION = 'translation.rollback';
export const TRANSLATION_TRANSLATE_PERMISSION = 'translation.translate';

// Product SDS
export const PRODUCT_EMBED_MANAGE_PERMISSION = 'product.embed_manage';
export const PRODUCT_SDS_ADD_PERMISSION = 'product.sds.add';
export const PRODUCT_SDS_REPLACE_PERMISSION = 'product.sds.replace';
export const PRODUCT_SDS_DELETE_PERMISSION = 'product.sds.delete';
